"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
var ListItemText = function (_a) {
    var classes = _a.classes, children = _a.children, _b = _a.disableTypography, disableTypography = _b === void 0 ? false : _b, _c = _a.inset, inset = _c === void 0 ? false : _c, primary = _a.primary, primaryTypographyProps = _a.primaryTypographyProps, secondary = _a.secondary, secondaryTypographyProps = _a.secondaryTypographyProps;
    return (react_1.default.createElement(ListItemText_1.default, { classes: classes, disableTypography: disableTypography, inset: inset, primary: primary, primaryTypographyProps: primaryTypographyProps, secondary: secondary, secondaryTypographyProps: secondaryTypographyProps }, children));
};
exports.default = ListItemText;
